import { render, staticRenderFns } from "./marks.vue?vue&type=template&id=7502993e&scoped=true&"
import script from "./marks.vue?vue&type=script&lang=js&"
export * from "./marks.vue?vue&type=script&lang=js&"
import style0 from "./marks.vue?vue&type=style&index=0&id=7502993e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7502993e",
  null
  
)

export default component.exports